export default __webpack_public_path__ + "f9f09b997f19f8ce135b41ffbdfc5f69.png";